import { renderSvelteComponent } from './utils/render.js';
import { csv } from 'd3-fetch';
import SmallDisplay from './components/SmallDisplay.svelte';

import { MONITORING_RESULTS_URL } from './constants.js';

import { initFrameAndPoll } from '@newswire/frames';

initFrameAndPoll();

async function main() {
  // Read in your data
  const monitoring_results = await csv(MONITORING_RESULTS_URL, function (d) {
    return {
      year: new Date(+d.sample_year, 0),
      pwsid: d.pwsid,
      arsenic: +d.arsenic,
      nitrate: +d.nitrate,
      tcp: +d.tcp,
    };
  });

  function draw(container) {
    const pwsid = container.getAttribute('name');

    let monitoring_data = monitoring_results.filter(function (d) {
      return d.pwsid == pwsid;
    });

    renderSvelteComponent(SmallDisplay, container, {
      monitoringResults: monitoring_data,
      pwsid,
    });
  }

  let containers = document.getElementsByClassName('component');
  for (let i of containers) {
    draw(i);
  }
}

main();
